import { Component, Input } from '@angular/core';

@Component({
  selector: 'tooltipControl',
  templateUrl: 'tooltip-control.component.html',
  styleUrls: ['./tooltip-control.component.scss']
})
export class TooltipControlComponent {

  @Input() displayText: string = "";
  @Input() content: string = ""
  @Input() isMandatory: boolean = false;
  @Input() ngclass: string = "";
  @Input() displayPosition: string = "right";

}
